<template>
  <div class="profile">
    <div class="profile-preview">
      <div class="profile-preview_sticky">
        <div class="d-flex flex-column align-center">
          <div v-if="isLoad" class="w-100">
            <div style="width:220px;"></div>
            <v-skeleton-loader type="card-avatar"></v-skeleton-loader>
          </div>
          <div v-else >
            <div class="avatar-wrapper ma-5 mt-0">
              <PsychologistAvatar :profile="profile" />
            </div>
            <div class="d-flex align-center psychologist-title">
              <span class="title">{{ profile.name + " " + profile.surname }}</span>
              <img src="@/assets/images/account-approved.svg">
            </div>
            <div class="text-center psychologist-subtitle">
              <ExperienceText :years="profile.experience_ages" />
            </div>
            <div class="psychologist-prices d-flex flex-column align-center">
              <div class="price" v-if="getConsultationType1Price && getConsultationType1Price.price">
                {{ $vuetify.lang.t("$vuetify.view.common.individualSession") }} - {{getConsultationType1Price.price}} ₴
              </div>
              <div class="price" v-if="profile.works_with_couples && getConsultationType2Price && getConsultationType2Price.price">
                {{ $vuetify.lang.t("$vuetify.view.common.couplesSession") }} - {{getConsultationType2Price.price}} ₴
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="profile-details d-flex flex-column">
      <div v-if="isLoad" class="details-block">
        <v-skeleton-loader type="paragraph"></v-skeleton-loader>
      </div>
      <div v-else class="details-block d-flex flex-column">
        <div class="block__title">{{ $vuetify.lang.t("$vuetify.view.psychDescrModal.methodOfWork") }}</div>
        <div class="block__body">
          <div 
            v-for="method in profile.main_treatment_methods"
            :key="method"
          >
            {{ method }}
          </div>
        </div>
      </div>
      <div class="details-divider"></div>
      <div v-if="isLoad" class="details-block">
        <v-skeleton-loader type="paragraph"></v-skeleton-loader>
      </div>
      <div v-else class="details-block d-flex flex-column">
        <div class="block__title">{{ $vuetify.lang.t("$vuetify.view.common.aboutSpecialist") }}</div>
        <div class="block__body">
          <div ref="aboutTextBlock" class="about-text__wrapper" :class="{ 'collapsed': !expandedAbout, 'gradient-after': isOverflowAbout && !expandedAbout}">
            {{ profile.about_info }}
          </div>
          <div class="d-flex">
            <span 
              class="show-less-more"
              :class="{ 'less': expandedAbout }"
              v-if="isOverflowAbout"
              @click="expandedAbout = !expandedAbout"
            >
              <span>{{ expandedAbout ? $vuetify.lang.t("$vuetify.view.common.less") : $vuetify.lang.t("$vuetify.view.common.more") }}</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7" fill="none">
                <path d="M10.6301 1.34003L5.88013 6.09003L1.12012 1.33002" stroke="#00A3B7" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
          </div>
        </div>
      </div>
      <div class="details-divider"></div>
      <div v-if="isLoad" class="details-block">
        <v-skeleton-loader type="paragraph"></v-skeleton-loader>
      </div>
      <div v-else class="details-block d-flex flex-column">
        <div class="block__title">{{ $vuetify.lang.t("$vuetify.view.common.education") }}</div>
        <div class="block__body education__wrapper">
          <div 
            v-for="(education, i) in this.profile.education"
            :key="i"
            :class="{ 'hidden-item': !showAllEd && i > 1 }"
          >
          {{ education.year }} - {{ education.desc }}
          </div>
        </div>
        <div class="d-flex">
          <span 
            class="show-less-more"
            :class="{ 'less': showAllEd }"
            v-if="profile.education.length > 2"
            @click="showAllEd = !showAllEd"
          >
            <span>{{ showAllEd ? $vuetify.lang.t("$vuetify.view.common.less") : $vuetify.lang.t("$vuetify.view.common.more") }}</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7" fill="none">
              <path d="M10.6301 1.34003L5.88013 6.09003L1.12012 1.33002" stroke="#00A3B7" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
        </div>
      </div>
      <div class="details-divider"></div>
      <div v-if="isLoad" class="details-block">
        <v-skeleton-loader type="paragraph"></v-skeleton-loader>
      </div>
      <div v-else class="details-block d-flex flex-column">
        <div class="block__title">{{ $vuetify.lang.t("$vuetify.view.common.worksWith") }}</div>
        <div class="block__body">
          <ul class="aswers">
            <li
              v-for="(answer, i) in getAnswers"
              :key="i"
              :class="{ 'hidden-item': !showAllAnswers && i > 8 }"
            >
              {{answer}}
            </li>
          </ul>
          <div class="d-flex">
            <span 
              class="show-less-more"
              :class="{ 'less': showAllAnswers }"
              v-if="getAnswers.length > 9"
              @click="showAllAnswers = !showAllAnswers"
            >
              <span>{{ showAllAnswers ? $vuetify.lang.t("$vuetify.view.common.less") : $vuetify.lang.t("$vuetify.view.common.more") }}</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7" fill="none">
                <path d="M10.6301 1.34003L5.88013 6.09003L1.12012 1.33002" stroke="#00A3B7" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
          </div>
        </div>
      </div>
      <div class="details-divider"></div>
      <div v-if="isLoad" class="details-block">
        <v-skeleton-loader type="paragraph"></v-skeleton-loader>
      </div>
      <div v-else class="details-block d-flex flex-column">
        <div class="block__title">{{ $vuetify.lang.t("$vuetify.view.common.typeOfConsultation") }}</div>
        <div class="block__body">
          <consultation-type-switcher :show-couples-variant="profile.works_with_couples"></consultation-type-switcher>
        </div>
      </div>
      <div class="details-divider"></div>
      <div v-if="isLoad" class="details-block">
        <v-skeleton-loader type="paragraph"></v-skeleton-loader>
      </div>
      <div v-else class="details-block d-flex flex-column">
        <div class="block__title">{{ $vuetify.lang.t("$vuetify.view.common.schedule") }}</div>
        <div class="block__body">
          <showDateTimePicker
            :handle-user-select-data="savePsychologistAndTimeSlotData"
            :default-value="profile"
            :slot-type="getSelectedConsultationType"
            :select-calendar-id="selectCalendarId"
            @userSelect="userSelect"
            >
            {{
              $vuetify.lang.t(
                "$vuetify.main.patientDashboard.ourPsychologists.chooseTime"
              )
            }}
          </showDateTimePicker>

          <div v-if="selectedSlot.time && showButton" class="consult-select-btn__wrapper mt-10">
            <button class="consult-select-btn primary" @click="callSaveNewPsychologistOnServer">
              {{ $vuetify.lang.t("$vuetify.view.common.сhoose") }} {{ selectedSlot.data }} {{ selectedSlot.time }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ExperienceText from '@/components/UI/ExperienceText'
import showDateTimePicker from '@/components/UI/showDateTimePicker'
import ConsultationTypeSwitcher from '@/components/UI/ConsultationTypeSwitcher'
import PsychologistAvatar from '@/components/main/ShowPsychologist/PsychologistAvatar'

export default {
  name: 'PsychologistData',
  components: {
    ExperienceText,
    showDateTimePicker,
    ConsultationTypeSwitcher,
    PsychologistAvatar
  },
  props: {
    profile: {
      type: Object,
      required: true,
      default: () => {},
    },
    selectCalendarId: {
      type: String,
      required: false,
      default: null,
    },
    handleSelectProfileSlot: {
      type: Function,
      required: false,
      default: () => function () {},
    },
    showButton: {
      type: Boolean,
      required: false,
      default: () => true,
    },
    isLoad: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    savePsychologistAndTimeSlot: {
      type: Function,
      required: false,
      default: () => function () {},
    },
    saveNewPsychologistOnServer: {
      type: Function,
      required: false,
      default: () => function () {},
    },
  },
  data() {
    return {
      showAllEd: false,
      showAllAnswers: false,
      expandedAbout: false,
      isOverflowAbout: false,
      selectedData: {},
      selectedSlot: {},
    };
  },
  mounted() {
    this.checkOverflowAbout();
  },
  computed: {
    getSelectedConsultationType () {
      return this.$store.getters['consultation_type/getSelectedConsultationType']
    },
    localisation () {
      return this.$store.getters['app/getSelectedLocale']
    },
    getConsultationType1Price () {
      let filtered = this.profile.prices.filter(item => item.consultation_type_id === 1);
      if (!filtered.length) return null;
      return filtered[0]
    },
    getConsultationType2Price () {
      let filtered = this.profile.prices.filter(item => item.consultation_type_id === 2);
      if (!filtered.length) return null;
      return filtered[0]
    },
    getAnswers () {
      let values = [];
      Object.keys(this.profile.answers).forEach(key => {
        if (this.profile.answers[key].length) {
          
          this.profile.answers[key].forEach(answer => {
            let answer_text = '';
            
            if(key == 'relationship_problems') {
              answer_text = this.$vuetify.lang.t('$vuetify.view.psychologists.specialization.relationship_problems') + ': ';
            }

            answer_text = answer_text + answer;

            values.push(answer_text);
          });
        }
      });
      return values;
    },
  },
  watch: {
    profile () {
      this.$nextTick(() => {
        this.checkOverflowAbout();
      });
    },
    isLoad () {
      this.$nextTick(() => {
        this.checkOverflowAbout();
      });
    }
  },
  methods: {
    userSelect(date) {
      if (date) {
        this.selectedSlot = {
          data: date.date.translated,
          time: date.slot.time,
        };
      } else {
        this.selectedSlot = {};
      }
    },
    currentLocal (text) {
      if (this.localisation === 'ru' && text.ru) return text.ru
      else if (this.localisation === 'uk' && text.uk) return text.uk
      else return text.ru ? text.ru : text.uk
    },
    checkOverflowAbout() {
      const el = this.$refs.aboutTextBlock;
      if (el) {
        this.isOverflowAbout = this.expandedAbout ? true : el.scrollHeight > el.clientHeight;
      }
    },
    savePsychologistAndTimeSlotData(psychologistInfo = {}) {
      this.selectedData = psychologistInfo;
      this.handleSelectProfileSlot(this.profile, this.selectedData);
      this.savePsychologistAndTimeSlot(psychologistInfo);
    },
    callSaveNewPsychologistOnServer() {
      this.saveNewPsychologistOnServer(this.profile.id);
    },
  }
}
</script>

<style lang="scss" scoped>
.w-100 {
  width: 100%;
}
.consult-select-btn__wrapper {
  display: flex;
}
.consult-select-btn {
  max-width: 100%;
  color: #F4F4F4;
  background: #00A3B7;
  border-radius: 8px;
  padding: 9px 22px;
}
.profile-preview_sticky {
  position: sticky;
  top: 110px;
}
.about-text__wrapper {
  overflow: hidden;
  transition: max-height 0.3s ease;
  max-height: none;
  position: relative;
  white-space: pre-line;
}
.about-text__wrapper.gradient-after:after {
  content: "";
  display: block;
  width: 100%;
  height: 40px;
  bottom: 0px;
  position: absolute;
  background: linear-gradient(360deg, #FFFFFF 7.5%, rgba(255, 255, 255, 0) 95%);
}
.about-text__wrapper.collapsed {
  max-height: 144px;
}
.hidden-item {
  display: none;
}
.show-less-more {
  color: #00A3B7;
  display: flex;
  column-gap: 12px;
  align-items: center;
  margin-top: 5px;
  cursor: pointer;
}
.show-less-more.less svg {
  transform: rotate(180deg);
}
.profile {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  column-gap: 5rem;
  row-gap: 30px;
}
.profile-preview {
  /* width: 100%; */
  flex-grow: 1;
  max-width: 282px;
}
.profile-details {
  /* width: 100%; */
  flex-grow: 1;
  flex-basis: 50%;
  max-width: 550px;
}
.psychologist-title {
  column-gap: 18px;
  color: #575756;
}
.psychologist-title .title {
  font-weight: 400;
  font-size: 20px;
  text-align: center;
}
.psychologist-subtitle {
  font-weight: 400;
  font-size: 16px;
  color: #575756;
  margin-top: 7px;
}
.psychologist-prices {
  margin-top: 38px;
  font-weight: 400;
  font-size: 16px;
  color: #00A3B7;
  row-gap: 5px;
}
.profile-details {
  row-gap: 24px;
}
.profile-details .details-block{
  row-gap: 2px;
}
.details-block .block__title {
  font-weight: 400;
  font-size: 20px;
  color: #00A3B7;
  margin-bottom: 5px;
}
.details-block .block__body {
  font-weight: 400;
  font-size: 16px;
  color: #575756;
}

.profile-details .details-divider {
  height: 1px;
  background: #D9E4EB;
}
.aswers {
  padding-left: 24px !important;
}
.aswers li::marker {
    color: #00A3B7;
}
.education__wrapper {
  display: flex;
  flex-direction: column;
  row-gap: 19px;
}

.avatar-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media screen and (max-width: 1300px) {
  .profile {
    column-gap: 40px;
  }
}

</style>